// @flow

import GlossaryModal from "./GlossaryModal"

export default GlossaryModal



// WEBPACK FOOTER //
// ./src/Kiosk/GlossaryModal/index.js